import { useMemo } from 'react';

import { DataPipeline } from '@finley-technologies/finley-types';
import { DbGraphUtils } from '@finley-technologies/tape-builder';

import { useGetLatestMeshDocumentMetadataQuery } from 'packages/dataPipeline/requests/dataPipeline.gql.generated';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export const useLatestMeshDocumentMetadata = ({
  organizationId,
  forceNetworkFetch = false,
}: {
  organizationId: string;
  forceNetworkFetch?: boolean;
}): {
  latestMeshDocumentMetadata: DataPipeline.MeshDocumentMetadata[];
  loading: boolean;
  error?: Error;
} => {
  const flags = useFeatureFlags();
  const fetchPolicy = forceNetworkFetch ? 'network-only' : 'cache-first';

  const { data, loading, error } = useGetLatestMeshDocumentMetadataQuery({
    variables: {
      organizationId,
      creditFacilitySlugsToHide: flags.creditFacilitySlugsToHide ?? [],
    },
    fetchPolicy,
  });

  const latestMeshDocumentMetadata = useMemo(() => {
    return (
      data?.latestMeshDocumentMetadata.map((serializedMetadata) => {
        return DbGraphUtils.deserializeMeshDocumentMetadata(serializedMetadata);
      }) || []
    );
  }, [data?.latestMeshDocumentMetadata]);

  return {
    latestMeshDocumentMetadata,
    loading,
    error,
  };
};
